module.exports = __webpack_public_path__ + "static/media/grid-item-a7.6646045b.png";